module.exports = __webpack_public_path__ + "assets/img/89c7-ec.svg";